<div class="modal-content">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="modalRef.hide()"><span aria-hidden="true">&times;</span></button>

        <label class="modal-title text-warning">
          <span class="icon text-warning fa fa-exclamation-triangle"></span>
          Atenção
        </label>
    </div>
    <div class="modal-body">
      <div class="text-center title-message">
        <strong>Existem celulares não validados!</strong>
        <p>Para assinar digitalmente, é necessário que os celulares estejam validados.<br />
        Deseja tentar validá-los antes de enviar a proposta para a análise?</p>
      </div>
      <form class="forms modal-alterar-valor centered" style="flex-direction: column">

          <div class="inputs form-column">
              <label class="input-label" for="telefonesCliente">Cliente</label>
              <app-telefone-base
                  [detalhesClienteForm]="clienteForm"
                  [needsConfirmation]="true"
                  [isConfirmado]="isConfirmadoTelefone(cliente)"
                  [isRemovable]="false"
                  [readOnly]="true"
                  [cliente]="cliente"
                  [proposta]="proposta"></app-telefone-base>
          </div>
          <div class="inputs form-column" *ngIf="avalistas.length">
              <label class="input-label">Avalistas</label>
              <div *ngFor="let avalista of avalistas; index as i">
                {{ avalista.nomeCliente}}
                <app-telefone-base
                    [detalhesClienteForm]="avalistasForm[i]"
                    [needsConfirmation]="true"
                    [isConfirmado]="isConfirmadoTelefone(avalista)"
                    [isRemovable]="false"
                    [readOnly]="true"
                    [proposta]="proposta"
                    [cliente]="avalista"></app-telefone-base>
              </div>
          </div>
        </form>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="marginT30 form-group tab-buttons">
          <button
            type="button"
            class="bt-back btn btn-border-orange pull-left"
            [disabled]="isTodosValidados"
            (click)="close()">
            Enviar sem validação
          </button>

          <button
            type="button"
            class="bt-go btn btn-full-orange pull-right"
            [disabled]="!isTodosValidados"
            (click)="close()">
            Enviar com validação
          </button>
        </div>
      </div>
    </div>
  </div>
  